/**
 * Thin chip-label wrappers for collaboration list / Overview builders.
 * Avoid importing page-level AcceptedCampaignInviteSteps barrels (compensation + journey re-exports).
 */
import { getJourneyChipLabel } from './journeyDefinition';

export const getNextStepChipLabel = (collaboration) => getJourneyChipLabel(collaboration, 'brand');

export const getNextStepChipLabelInfluencer = (collaboration) => (
  getJourneyChipLabel(collaboration, 'influencer')
);
